/**
 * Back to Top — Shows/hides the back-to-top button based on scroll position.
 * The button HTML lives in sections/back-to-top.liquid.
 */
(function () {
  'use strict';

  var button = document.getElementById('back-to-top-btn');
  if (!button) return;

  var SHOW_THRESHOLD = 600;

  function toggle() {
    if (window.scrollY > SHOW_THRESHOLD) {
      button.classList.remove('opacity-0', 'translate-y-4', 'pointer-events-none');
      button.classList.add('opacity-100', 'translate-y-0');
    } else {
      button.classList.remove('opacity-100', 'translate-y-0');
      button.classList.add('opacity-0', 'translate-y-4', 'pointer-events-none');
    }
  }

  button.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  var ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function() {
        toggle();
        ticking = false;
      });
    }
  }, { passive: true });

  // Set initial state
  toggle();
})();
